import { EnumTipoPropagandaLocal } from "model/enums/enum-tipo-propaganda-local";
import { EnumTipoPropagandaDestaque } from "model/enums/enum-tipo-propaganda-destaque";
import { guidEmpty } from "utils/guid-empty";

export class PropagandaModel {
    constructor(
        public id:string = guidEmpty(),
        public revendaId: string | null = null,
        public html:string = '',
        public descricao:string = '',
        public ativo:boolean = true,
        public tempoExibicao:number = 0,
        public tempoMinimo:number = 0,
        public ignoraVisualizacao:boolean = true,
        public respostasDisponiveis:string[] = [],
        public dtInicial:string = '',
        public dtFinal:string = '',
        public local:EnumTipoPropagandaLocal = EnumTipoPropagandaLocal.Ambos,
        public destaque:EnumTipoPropagandaDestaque = EnumTipoPropagandaDestaque.NaoInformado,
    ) { }
}